const Tasya = [
    {
        area_id: 9,
        link: 'https://wa.me/628119125005?text=Halo%20Tasya%20%F0%9F%98%8A%2C%0A%0AMau%20tanya%20tentang%20simulasi%20cicilan%20terkait'
    },{
        area_id: 10,
        link: 'https://wa.me/628111475505?text=Halo%20Tasya%20%F0%9F%98%8A%2C%0A%0AMau%20tanya%20tentang%20simulasi%20cicilan%20terkait'
    },{
        area_id: 11,
        link: 'https://wa.me/628119555051?text=Halo%20Tasya%20%F0%9F%98%8A%2C%0A%0AMau%20tanya%20tentang%20simulasi%20cicilan%20terkait'
    },{
        area_id: 12,
        link: 'https://wa.me/628118845505?text=Halo%20Tasya%20%F0%9F%98%8A%2C%0A%0AMau%20tanya%20tentang%20simulasi%20cicilan%20terkait'
    },{
        area_id: 13,
        link: 'https://wa.me/62811959605?text=Halo%20Tasya%20%F0%9F%98%8A%2C%0A%0AMau%20tanya%20tentang%20simulasi%20cicilan%20terkait'
    },{
        area_id: 14,
        link: 'https://wa.me/62811959605?text=Halo%20Tasya%20%F0%9F%98%8A%2C%0A%0AMau%20tanya%20tentang%20simulasi%20cicilan%20terkait'
    },{
        area_id: 15,
        link: 'https://wa.me/628111475505?text=Halo%20Tasya%20%F0%9F%98%8A%2C%0A%0AMau%20tanya%20tentang%20simulasi%20cicilan%20terkait'
    },{
        area_id: 16,
        link: 'https://wa.me/628119555051?text=Halo%20Tasya%20%F0%9F%98%8A%2C%0A%0AMau%20tanya%20tentang%20simulasi%20cicilan%20terkait'
    },{
        area_id: 17,
        link: 'https://wa.me/628118845505?text=Halo%20Tasya%20%F0%9F%98%8A%2C%0A%0AMau%20tanya%20tentang%20simulasi%20cicilan%20terkait'
    }
]

export default Tasya